import { render, staticRenderFns } from "./ReBPStageEdit.vue?vue&type=template&id=464b1bc4&scoped=true"
import script from "./ReBPStageEdit.vue?vue&type=script&lang=js"
export * from "./ReBPStageEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464b1bc4",
  null
  
)

export default component.exports